import { useCallback } from 'react';

import type { LineMeasurementPoint } from '../../../model/screencast-tooltips/screencastLineMeasurementResolver';

import type { TransformState } from './types';

type UseImagePointResolverParams = {
  imageNaturalWidth: number;
  imageNaturalHeight: number;
  transformState: TransformState;
};

export function useImagePointResolver({
  imageNaturalWidth,
  imageNaturalHeight,
  transformState,
}: UseImagePointResolverParams) {
  return useCallback(
    (wrapper: HTMLDivElement, clientX: number, clientY: number): LineMeasurementPoint | null => {
      if (transformState.scale <= 0) {
        return null;
      }

      const wrapperRect = wrapper.getBoundingClientRect();
      const wrapperX = clientX - wrapperRect.left;
      const wrapperY = clientY - wrapperRect.top;

      const x = (wrapperX - transformState.positionX) / transformState.scale;
      const y = (wrapperY - transformState.positionY) / transformState.scale;

      if (x < 0 || y < 0 || x > imageNaturalWidth || y > imageNaturalHeight) {
        return null;
      }

      return { x, y };
    },
    [imageNaturalHeight, imageNaturalWidth, transformState],
  );
}
